/**
 * Composable for interacting with Usercentrics Consent Management Platform (CMP) browser UI.
 * @see https://usercentrics.com/docs/web/features/api/control-ui/
 * @see https://usercentrics.com/docs/web/features/api/control-functionality/
 */
export function usercentricsCmp() {
  /**
   * Utility function that brings up the Usercentrics CMP UI when called, if Usercentrics CMP is loaded.
   */
  function toggleDisplay() {
    // NOTE: installing @types/usercentrics-browser-ui is required for TypeScript types.
    const ucCmp = window.__ucCmp;
    if (!ucCmp) { // despite type definition, __ucCmp may be undefined if Usercentrics script did not load
      console.warn('Usercentrics CMP is not available');
      return;
    }
    ucCmp.showSecondLayer();
  }

  return {
    toggleDisplay
  };
}
